module.exports = __webpack_public_path__ + "static/media/capacity.f612aee4.svg";